import { absenceDayPartLabel } from '../../absence/public';
import { Button, Stack, Typography } from '@mui/material';
import { DefinitionList, SectionCard } from '../../../design-system';

export function TimeOffCancellationSummary({ values, originalRequestHref, status }: { values: Record<string, unknown>; originalRequestHref?: string; status?: string }) {
  const text = (key: string) => typeof values[key] === 'string' ? values[key] as string : '';
  const start = text('startDate').replaceAll('-', '.');
  const end = text('endDate').replaceAll('-', '.');
  const dayPart = text('dayPart');
  const quantity = Number(text('quantity'));
  const completed = status === 'COMPLETED';
  const preserved = status === 'DENIED' || status === 'CANCELLED';
  const pending = status === 'IN_PROGRESS' || status === 'DRAFT' || status === 'NEEDS_CHANGES';
  return <SectionCard title={<Typography component="h2" variant="h6">휴가 취소 요청</Typography>} showDivider={false} bodyPadding="standard">
    <Stack spacing={2}>
      <DefinitionList items={[
        ['휴가 유형', text('timeOffTypeDescriptor')],
        ['취소할 기간', start === end ? start : `${start} – ${end}`],
        ...(absenceDayPartLabel(dayPart) ? [["사용 시간대", absenceDayPartLabel(dayPart)]] as [string, string][] : []),
        [completed ? '반환량' : preserved ? '기존 사용량' : pending ? '반환 예정' : '취소 대상 사용량', `${Number.isFinite(quantity) ? quantity.toLocaleString('ko-KR') : text('quantity')}${text('unitOfTime') === 'HOURS' ? '시간' : '일'}`],
        ['취소 사유', <Typography key="reason" variant="body2" sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{text('reason') || '사유 미등록'}</Typography>],
      ]} />
      {originalRequestHref ? <Button component="a" href={originalRequestHref} variant="text" sx={{ alignSelf: 'flex-start' }}>원래 휴가 신청 보기</Button> : null}
    </Stack>
  </SectionCard>;
}
